import React from 'react';
import StandardModal from '../../Shared/UI/StandardModal/components/StandardModal';
import StandardModalLayout from '../../Shared/UI/StandardModalLayout/components/StandardModalLayout';
import { useCapabilities } from '../../Shared/capabilities';
import { useHeaderState, useHeaderActions } from './HeaderContext';
import { deleteSession } from '../../Account/components/restApi';
import HeaderExtensionsList from './HeaderExtensionsList';
import styles from './NavigationMenu.module.scss';

const RootGroup = ({ onClose, onOpenGroup }) => {
  const capabilities = useCapabilities();
  const { openLoginWizard } = useHeaderActions();

  return (
    <>
      {capabilities.showAdminCapabilities && (
        <button
          className={styles.navItem}
          onClick={() => onOpenGroup('admin')}
          type="button"
        >
          Admin
        </button>
      )}
      <button
        className={styles.navItem}
        onClick={() => onOpenGroup('community')}
        type="button"
      >
        Community
      </button>
      {capabilities.showAccountNavigation && (
        <button
          className={styles.navItem}
          onClick={() => onOpenGroup('your-account')}
          type="button"
        >
          Your Account
        </button>
      )}
      {capabilities.showLoginNavigation && (
        <>
          {/* Keep Consent Preferences and Login button together */}
          <button
            className={styles.navItem}
            onClick={() => {
              onClose();
              window.displayPreferenceModal();
            }}
            type="button"
          >
            Consent Preferences
          </button>
          <button
            className={styles.navItem}
            onClick={() => {
              onClose();
              openLoginWizard();
            }}
            type="button"
          >
            Log In
          </button>
        </>
      )}
    </>
  );
};

const AdminGroup = ({ onClose }) => {
  const capabilities = useCapabilities();

  return (
    <>
      {capabilities.showUserInvitationsNavigation && (
        <a
          className={styles.navItem}
          href="/user_invitations"
          onClick={onClose}
        >
          User Invitations
        </a>
      )}
      {capabilities.showUsersNavigation && (
        <a
          className={styles.navItem}
          href="/users"
          onClick={onClose}
        >
          Users
        </a>
      )}
      {capabilities.showRolesNavigation && (
        <a
          className={styles.navItem}
          href="/roles"
          onClick={onClose}
        >
          Roles
        </a>
      )}
      {capabilities.showRestrictedActionsNavigation && (
        <a
          className={styles.navItem}
          href="/restricted_actions"
          onClick={onClose}
        >
          Restricted Actions
        </a>
      )}
      {capabilities.showInterestsNavigation && (
        <a
          className={styles.navItem}
          href="/interests"
          onClick={onClose}
        >
          Interests
        </a>
      )}
      {capabilities.showSkillsNavigation && (
        <a
          className={styles.navItem}
          href="/skills"
          onClick={onClose}
        >
          Skills
        </a>
      )}
      {capabilities.showAdminDiscourseNavigation && (
        <a
          className={styles.navItem}
          href="/discourse/admin"
          onClick={onClose}
        >
          Admin Discourse
        </a>
      )}
      {capabilities.showTagsNavigation && (
        <a
          className={styles.navItem}
          href="/tags"
          onClick={onClose}
        >
          Tags
        </a>
      )}
      {capabilities.showJobDescriptionsNavigation && (
        <a
          className={styles.navItem}
          href="/job_descriptions"
          onClick={onClose}
        >
          Job Descriptions (Not Implemented)
        </a>
      )}
      {capabilities.showJobDescriptionsFromFileUploadNavigation && (
        <a
          className={styles.navItem}
          href="/job_descriptions_from_file_upload"
          onClick={onClose}
        >
          Job Descriptions from File Upload (Not Implemented)
        </a>
      )}
      {capabilities.showBiopharmaGroupsNavigation && (
        <a
          className={styles.navItem}
          href="/biopharma_groups"
          onClick={onClose}
        >
          Biopharma Groups
        </a>
      )}
      {capabilities.showAllJobProspectsNavigation && (
        <a
          className={styles.navItem}
          href="/all_job_prospects"
          onClick={onClose}
        >
          All Job Prospects
        </a>
      )}
      {capabilities.showArchivedJobProspectsNavigation && (
        <a
          className={styles.navItem}
          href="/archived_job_prospects"
          onClick={onClose}
        >
          Archived Job Prospects
        </a>
      )}
      {capabilities.showEnrollmentManagementNavigation && (
        <a
          className={styles.navItem}
          href="/admin/enrollment_management"
          onClick={onClose}
        >
          Enrollment Management
        </a>
      )}
      {capabilities.showJobDescriptionsFromExternalWebsitesNavigation && (
        <a
          className={styles.navItem}
          href="/job_descriptions_from_external_websites"
          onClick={onClose}
        >
          Job Descriptions from External Websites
        </a>
      )}
      {capabilities.showExternalJobBoardsNavigation && (
        <a
          className={styles.navItem}
          href="/external_job_boards"
          onClick={onClose}
        >
          External Job Boards
        </a>
      )}
      {capabilities.showLinkTextToAvoidInJobSearchesNavigation && (
        <a
          className={styles.navItem}
          href="/link_text_to_avoid_in_job_searches"
          onClick={onClose}
        >
          Link Text to Avoid
        </a>
      )}
      {capabilities.showSidekiqNavigation && (
        <a
          className={styles.navItem}
          href="/sidekiq"
          onClick={onClose}
        >
          Sidekiq Dashboard
        </a>
      )}
      {capabilities.showJobProspectsStatsNavigation && (
        <a
          className={styles.navItem}
          href="/job_prospects_stats"
          onClick={onClose}
        >
          Job Prospects Stats
        </a>
      )}
      {capabilities.showLoginRecordsNavigation && (
        <a
          className={styles.navItem}
          href="/login_records"
          onClick={onClose}
        >
          Login Records
        </a>
      )}
      {capabilities.showSessionTokensNavigation && (
        <a
          className={styles.navItem}
          href="/session_tokens"
          onClick={onClose}
        >
          Session Tokens
        </a>
      )}
    </>
  );
};

const CommunityGroup = ({ onClose }) => {
  const capabilities = useCapabilities();

  return (
    <>
      <a
        className={styles.navItem}
        href="/feed"
        onClick={onClose}
      >
        Feed
      </a>
      {capabilities.showGroupsNavigation && (
        <a
          className={styles.navItem}
          href="/groups"
          onClick={onClose}
        >
          Groups
        </a>
      )}
      {capabilities.showEventsNavigation && (
        <a
          className={styles.navItem}
          href="/events"
          onClick={onClose}
        >
          Events
        </a>
      )}
      <a
        className={styles.navItem}
        href="/discourse/published"
        onClick={onClose}
      >
        Discourse
      </a>
    </>
  );
};

const YourAccountGroup = ({ onClose }) => {
  const capabilities = useCapabilities();
  const { onResponse, onError } = useHeaderActions();

  const handleLogout = () => {
    deleteSession({
      onResponse,
      onError,
      body: {
        authenticityToken: document.querySelector("meta[name='csrf-token']").getAttribute("content")
      },
    });
  };

  return (
    <>
      {capabilities.showProfileNavigation && (
        <a
          className={styles.navItem}
          href="/your_profile"
          onClick={onClose}
        >
          Your Profile
        </a>
      )}
      {capabilities.showJobProspectsNavigation && (
        <a
          className={styles.navItem}
          href="/job_prospects"
          onClick={onClose}
        >
          Your Job Prospects
        </a>
      )}
      {/* This button must always show in Account Group */}
      <button
        className={styles.navItem}
        onClick={() => {
          onClose();
          window.displayPreferenceModal();
        }}
        type="button"
      >
        Consent Preferences
      </button>
      {capabilities.showAccountSettingsNavigation && (
        <a
          className={styles.navItem}
          href="/your_account"
          onClick={onClose}
        >
          Settings
        </a>
      )}
      {capabilities.showLogoutNavigation && (
        <button
          className={styles.navItem}
          onClick={() => {
            onClose();
            handleLogout();
          }}
          type="button"
        >
          Log Out
        </button>
      )}
    </>
  );
};

const GROUP_COMPONENTS = {
  'root': RootGroup,
  'admin': AdminGroup,
  'community': CommunityGroup,
  'your-account': YourAccountGroup,
};

const NavigationMenu = () => {
  const state = useHeaderState();
  const { openNavigationMenu, closeNavigationMenu } = useHeaderActions();
  
  const GroupComponent = GROUP_COMPONENTS[state.header?.activeGroup];

  const modalBody = (
    <div className={styles.menuContainer}>
      <HeaderExtensionsList onItemClick={closeNavigationMenu} />
      {GroupComponent && (
        <GroupComponent 
          onClose={closeNavigationMenu}
          onOpenGroup={openNavigationMenu}
        />
      )}
    </div>
  );

  const modalFooter = (
    <button
      className={styles.closeButton}
      onClick={closeNavigationMenu}
      type="button"
    >
      Close
    </button>
  );

  return (
    <StandardModal
      isOpen={state.header?.navigationMenuOpen}
      contentLabel="Navigation Menu"
      onRequestClose={closeNavigationMenu}
    >
      <StandardModalLayout
        body={modalBody}
        footer={modalFooter}
      />
    </StandardModal>
  );
};

export default NavigationMenu;
